/**
 * Režim editačních vrstev.
 */
export enum EditorLayersMode {
    /**
     * Pro editaci se používá izolovaná *overlay* vrstva .
     */
    OVERLAY = 'OVERLAY',

    /**
     * Umožňujeme editovat vybrané datové vrstvy z katalogu vrstev.
     */
    DATA = 'DATA',
}
